import React from "react";

import { INextGenDashboardException } from "../../../services/zeos-api/contracts/Dashboard";
import {
  DashboardStatusBadge,
  DashboardStatusTone,
} from "./DashboardStatusBadge";

const SEVERITY_TONE: Record<string, DashboardStatusTone> = {
  alert: "error",
  watch: "warning",
  info: "info",
};

const SEVERITY_LABEL: Record<string, string> = {
  alert: "Alert",
  watch: "Watch",
  info: "Info",
};

interface IProps {
  exceptions: INextGenDashboardException[];
}

/**
 * DV-02 Sheet-1 Exception & Alert panel: structured, severity-coded rows (billing-integrity and
 * seasonal-band findings). Renders nothing when there is nothing to flag, so a clean property
 * shows no panel at all.
 */
export const DashboardExceptionPanel = ({ exceptions }: IProps) => {
  if (!exceptions || exceptions.length === 0) {
    return null;
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-3 text-sm font-semibold text-slate-900">
        Exceptions &amp; Alerts
      </div>
      <ul className="flex flex-col gap-2">
        {exceptions.map((exception, index) => (
          <li
            key={`${exception.category}-${exception.period ?? index}`}
            className="flex items-start gap-3 text-sm text-slate-700"
          >
            <DashboardStatusBadge
              tone={SEVERITY_TONE[exception.severity] ?? "neutral"}
              label={SEVERITY_LABEL[exception.severity] ?? exception.severity}
            />
            <span>{exception.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
